(function () {
  function getSliderParts(component) {
    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return null;

    const slides = Array.from(component.querySelectorAll('[id^="Slide-"]')).filter(
      (slide) => slide.clientWidth > 0 && !slide.classList.contains('pairfit-slide-clone')
    );

    if (slides.length < 2) return null;
    return { slider, slides };
  }

  function storageKey(slider) {
    return `pairfit-slide:${slider.id}`;
  }

  function scrollToSlide(slider, slides, index) {
    const safeIndex = ((index % slides.length) + slides.length) % slides.length;
    slider.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'instant' });
    slider.dispatchEvent(new Event('scroll', { bubbles: true }));
    return safeIndex;
  }

  function isSlideActive(slider, slide) {
    return Math.abs(slide.offsetLeft - slider.scrollLeft) < 8;
  }

  function syncSlideshowSlideLinks(component) {
    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    component.querySelectorAll('.slideshow__slide').forEach((slide) => {
      const link = slide.querySelector('.slideshow__slide-link');
      if (!link) return;

      const active = isSlideActive(slider, slide);
      link.style.pointerEvents = active ? 'auto' : 'none';

      if (active) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', '-1');
      }
    });
  }

  function patchSlideshowSlideLinks() {
    const SlideshowComponent = customElements.get('slideshow-component');
    if (!SlideshowComponent || SlideshowComponent.prototype.__pairfitSlideLinkPatched) return;

    const originalSetSlideVisibility = SlideshowComponent.prototype.setSlideVisibility;
    SlideshowComponent.prototype.setSlideVisibility = function (event) {
      originalSetSlideVisibility.call(this, event);
      syncSlideshowSlideLinks(this);
    };

    SlideshowComponent.prototype.__pairfitSlideLinkPatched = true;
  }

  function initSlideshowSlideLinks(component) {
    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const sync = () => syncSlideshowSlideLinks(component);
    slider.addEventListener('scroll', sync, { passive: true });
    sync();
    requestAnimationFrame(sync);
  }

  function initSlideshowStart(component, attempt = 0) {
    if (typeof component.setupLoopClone === 'function') {
      component.setupLoopClone();
    }

    const parts = getSliderParts(component);
    if (!parts) {
      if (attempt < 24) requestAnimationFrame(() => initSlideshowStart(component, attempt + 1));
      return;
    }

    const { slider, slides } = parts;
    const key = storageKey(slider);
    const savedIndex = parseInt(sessionStorage.getItem(key), 10);
    const startIndex =
      Number.isNaN(savedIndex) || savedIndex < 0 || savedIndex >= slides.length
        ? Math.floor(Math.random() * slides.length)
        : savedIndex;

    scrollToSlide(slider, slides, startIndex);
    sessionStorage.setItem(key, String(startIndex));
    syncSlideshowSlideLinks(component);

    let saveTimeout;
    slider.addEventListener(
      'scroll',
      () => {
        clearTimeout(saveTimeout);
        saveTimeout = setTimeout(() => {
          const currentIndex = slides.findIndex(
            (slide) => Math.abs(slide.offsetLeft - slider.scrollLeft) < 4
          );
          if (currentIndex >= 0) sessionStorage.setItem(key, String(currentIndex));
        }, 120);
      },
      { passive: true }
    );
  }

  function patchSliderLooping() {
    const SliderComponent = customElements.get('slider-component');
    if (!SliderComponent || SliderComponent.prototype.__pairfitLoopPatched) return;

    const originalOnButtonClick = SliderComponent.prototype.onButtonClick;

    SliderComponent.prototype.onButtonClick = function (event) {
      if (!this.enableSliderLooping) return originalOnButtonClick.call(this, event);

      event.preventDefault();

      const items = this.sliderItemsToShow;
      if (!items || items.length < 2 || !this.sliderItemOffset) {
        return originalOnButtonClick.call(this, event);
      }

      const isPrev = event.currentTarget.name === 'previous';
      const atStart = this.slider.scrollLeft <= 1;
      const atEnd = this.isSlideVisible(items[items.length - 1]);

      if (!isPrev && atEnd) {
        if (typeof this.setupLoopClone === 'function') this.setupLoopClone();
        if (this.loopCloneSlide) {
          this.setSlidePosition(this.loopCloneSlide.offsetLeft);
          return;
        }
        this.slider.scrollTo({ left: items[0].offsetLeft, behavior: 'instant' });
        this.slider.dispatchEvent(new Event('scroll', { bubbles: true }));
        return;
      }

      if (isPrev && atStart) {
        this.setSlidePosition(items[items.length - 1].offsetLeft);
        return;
      }

      originalOnButtonClick.call(this, event);
    };

    SliderComponent.prototype.__pairfitLoopPatched = true;
  }

  function enableProductCarouselLooping() {
    document.querySelectorAll('slider-component').forEach((component) => {
      if (component.closest('.product__media-wrapper')) return;
      if (!component.querySelector('button[name="next"]')) return;
      component.enableSliderLooping = true;
    });
  }

  function initWishlistButtons() {
    const storageKey = 'pairfit-wishlist';

    const getWishlist = () => {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || '[]');
      } catch {
        return [];
      }
    };

    const syncButtons = () => {
      const ids = getWishlist();
      document.querySelectorAll('.pairfit-product-card__wishlist[data-product-id]').forEach((button) => {
        button.classList.toggle('is-active', ids.includes(String(button.dataset.productId)));
      });
    };

    document.addEventListener('click', (event) => {
      const swatchLink = event.target.closest('.pairfit-product-card__swatch-link');
      if (swatchLink) {
        event.stopPropagation();
        return;
      }

      const button = event.target.closest('.pairfit-product-card__wishlist');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const productId = String(button.dataset.productId || '');
      if (!productId) return;

      const ids = getWishlist();
      const index = ids.indexOf(productId);
      if (index >= 0) {
        ids.splice(index, 1);
      } else {
        ids.push(productId);
      }

      localStorage.setItem(storageKey, JSON.stringify(ids));
      syncButtons();
    });

    syncButtons();
  }

  function initPairfitSliders() {
    patchSliderLooping();
    patchSlideshowSlideLinks();
    enableProductCarouselLooping();
    initWishlistButtons();
    document.querySelectorAll('slideshow-component').forEach((component) => {
      initSlideshowSlideLinks(component);
      initSlideshowStart(component);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPairfitSliders);
  } else {
    initPairfitSliders();
  }
})();
